import SearchIcon from "@mui/icons-material/Search";
import {
  Search,
  SearchContainer,
  SearchIconWrapper,
  StyledInputBase,
} from "./AppSearch.styles";
import React, { useState } from "react";
import GoToPage from "../../../GoToPage/GoToPage";
import useGoToPage from "../../../../hook/useGoToPage";
import { decodeURIComponentSafe } from "../../../../../explorer/utils/NavigationUtils";
import SimplePopover from "../../../../../explorer/components/Popover/SimplePopover";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { AppIconsSearch } from "../../../AppIcons";

export function AppSearch() {
  const [filter, setFilter] = useState<string>("");
  const [searchedPartLenOpen, setSearchedPartLenOpen] =
    useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState();
  const textRef = React.useRef();

  const id = anchorEl !== undefined ? "simple-popover" : undefined;

  const { t } = useTranslation();
  const goToPage = useGoToPage();

  const handleSubmit = (event: any) => {
    doSearch(event);
  };

  const doSearch = (event: any) => {
    let _s = decodeURIComponentSafe(filter);
    if (_s !== undefined && _s?.length < 2) {
      openSearchPartLenDialog();
      return;
    }
    if (_s) goToPage.spareParts.goToSearch(_s);
  };

  const openSearchPartLenDialog = () => {
    setSearchedPartLenOpen(true);
    setAnchorEl(textRef.current);
    // setTimeout(function () {
    // 	setSearchedPartLenOpen(false)
    // 	setAnchorEl(undefined);
    // }, 5000);//5 Second delay
  };

  return (
    <>
      <SearchContainer className="osh-hint-search">
        <Search sx={{ display: { xs: "none", sm: "block" } }}>
          <StyledInputBase
            placeholder={t("common.appSearch.SearchPart")}
            inputProps={{ "aria-label": "search" }}
            onChange={(event) => {
              setFilter(event.target.value.trim());
            }}
            inputRef={textRef}
            onKeyDown={(event: any) => {
              if (event.key === "Enter" && filter !== "") {
                handleSubmit(event);
              }
            }}
          />
          <SearchIconWrapper
            onClick={(event: any) => {
              handleSubmit(event);
            }}
          >
            <AppIconsSearch />
          </SearchIconWrapper>
        </Search>
      </SearchContainer>
      {searchedPartLenOpen ? (
        <SimplePopover
          anchorElement={anchorEl}
          setAnchorElement={setAnchorEl}
          message={t("common.spareparts.searchpage.search_code_warning")}
          showBelow={true}
          showToLeft={false}
          showCloseButton={true}
        />
      ) : (
        ""
      )}
    </>
  );
}
